export default {
    state: {
        initData: {}
    },
    mutations: {
        setInitData(state, value) {
            state.initData = value;
        },
    },
    actions: {},
}
